<template>
  <component
    :is="component.component.name"
    v-for="(component, index) in specificComponents"
    :key="`${keyPrefix}-${index}`"
    :component="component"
  ></component>
</template>

<script lang="ts">
// common
import Separator from '~/components/library/Separator.vue';
import FormContainer from '~/components/library/FormContainer.vue';
import Test from '~/components/theme7/components/Test.vue';
import InfoCard from '~/components/theme7/components/InfoCard.vue';
import TeamCard from '~/components/theme7/components/TeamCard.vue';
import LatestProperties from '~/components/theme7/properties/LatestProperties.vue';
import OurBlog from '~/components/theme7/blogs/OurBlog.vue';
import OurGuide from '~/components/theme7/components/OurGuide.vue';
import ContactFormCard from '~/components/theme7/components/ContactFormCard.vue';
import ManageCard from '~/components/library/ManageCard.vue';


export default defineNuxtComponent({
  props: {
    specificComponents: {
      required: false,
      default: () => [],
    },

    keyPrefix: {
      required: false,
      type: String,
      default: 'dynamicComponent',
    },
  },

  components: {
    Separator,
    FormContainer,
    Test,
    InfoCard,
    TeamCard,
    LatestProperties,
    OurBlog,
    OurGuide, 
    ManageCard,
    ContactFormCard,
  },
});
</script>
